
import './index.css';
import router from './routers';  // 默认查找index.js
import wiexin from './models/weixin';
import index from './models';
import order from './models/order';
import echart from './models/echart';
import { createBrowserHistory as createHistory } from 'history';
import createLoading from 'dva-loading';
//1. 引入dva
import dva from 'dva';
//2.创建dva的实力app对象
let app = new dva({
    history:createHistory()
});
// 3: 配置路由 app.router(fn);  （函数）
app.router(router);

// 5: 注册模块app.model({});  {namespace,state,effects,reducers}
app.model(wiexin);
app.model(index);
app.model(order);
app.model(echart);

//使用dva-loading组件
app.use(createLoading());

// 5.5: 卸载模块 app.unmodel();

// 6: app.start('#root')  
app.start('#root');


//ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
//export default app._store;